import { AlertTriangle } from "lucide-react";

export const PhiWarning = ({ testId = "phi-warning", children }) => (
  <p className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-900" data-testid={testId}>
    <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
    <span>
      {children ||
        "Do not include patient information, PHI, prescriptions, Social Security numbers, passwords, banking details or other confidential information."}
    </span>
  </p>
);

export const CompensationNotice = ({ testId = "compensation-notice" }) => (
  <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs leading-relaxed text-slate-600" data-testid={testId}>
    <p className="font-medium text-slate-800">Before you accept: confirm pay and payment terms directly</p>
    <p className="mt-1.5">
      FindRxStaff does not set, collect, hold, process or guarantee compensation, and does not process
      payments. You and the other party are responsible for agreeing the hourly rate, payment method,
      payment timing, taxes and any reimbursements. Confirm these terms before the shift begins.
    </p>
  </div>
);
